// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u2sD-","copyright":"Footer_copyright__2--ME"};